export default {
  namespaced: true,
  state: {
    // 用户信息
    userinfo: {}
  },
  actions: {
    /**
     * @description 设置用户数据
     * @param {Object} state vuex state
     * @param {*} userinfo userinfo
     */
    set ({ state, dispatch }, userinfo) {
      return new Promise(async resolve => {
        // store 赋值
        state.userinfo = userinfo
        // 持久化
        await dispatch('d2admin/db/set', {
          dbName: 'sys',
          path: 'uInfo.userinfo',
          value: userinfo,
          user: true
        }, { root: true })
        // end
        resolve()
      })
    },
    /**
     * @description 从数据库取用户数据
     * @param {Object} state vuex state
     */
    load ({ state, dispatch }) {
      return new Promise(async resolve => {
        // store 赋值
        state.userinfo = await dispatch('d2admin/db/get', {
          dbName: 'sys',
          path: 'uInfo.userinfo',
          defaultValue: {},
          user: true
        }, { root: true })
        // end
        resolve()
      })
    }
  }
}
